<template>
  <div>
    <el-alert
      title="审核库存单据时，有批次号的明细会自动登记到这里。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.batchNo" clearable placeholder="批次号" style="width:140px" @keyup.enter.native="search" />
      <el-input v-model="query.productNumber" clearable placeholder="产品编码" style="width:140px" @keyup.enter.native="search" />
      <el-input v-model="query.productName" clearable placeholder="产品名称" style="width:140px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="batchNo" label="批次号" width="160" />
      <el-table-column prop="productNumber" label="产品编码" width="140" />
      <el-table-column prop="productName" label="产品名称" min-width="160" show-overflow-tooltip />
      <el-table-column prop="supplierName" label="供应商" width="140" show-overflow-tooltip />
      <el-table-column label="生产日期" width="120">
        <template slot-scope="{ row }">{{ formatDate(row.mfgDate) }}</template>
      </el-table-column>
      <el-table-column label="失效日期" width="120">
        <template slot-scope="{ row }">{{ formatDate(row.expireDate) }}</template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
      <el-table-column prop="createDate" label="创建时间" width="170" />
      <el-table-column label="操作" width="180" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.batchId)">修改</el-button>
          <el-button type="text" @click="goTrace(row)">追溯</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.batchId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />

    <el-dialog :title="form.batchId ? '修改批次' : '新增批次'" :visible.sync="visible" width="560px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="产品">
          <el-select v-model="form.productId" filterable style="width:100%">
            <el-option v-for="p in products" :key="p.productId" :label="p.productNumber + ' / ' + p.productName" :value="p.productId" />
          </el-select>
        </el-form-item>
        <el-form-item label="批次号"><el-input v-model="form.batchNo" /></el-form-item>
        <el-form-item label="供应商"><el-input v-model="form.supplierName" /></el-form-item>
        <el-form-item label="生产日期">
          <el-date-picker v-model="form.mfgDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
        </el-form-item>
        <el-form-item label="失效日期">
          <el-date-picker v-model="form.expireDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listBatch, getBatch, saveBatch, updateBatch, deleteBatch } from '../../api/batch'
import { selectProduct } from '../../api/product'

function emptyForm() {
  return {
    batchId: '', productId: '', batchNo: '', supplierName: '', mfgDate: null, expireDate: null, remark: ''
  }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { batchNo: '', productNumber: '', productName: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false, saving: false, visible: false,
      form: emptyForm(), products: []
    }
  },
  created() {
    this.load()
    selectProduct().then(res => { this.products = res.data || [] }).catch(() => {})
  },
  methods: {
    formatDate(v) { return v ? String(v).substring(0, 10) : '-' },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listBatch({
        currentPage: this.page, pageSize: this.pageSize,
        batchNo: this.query.batchNo, productNumber: this.query.productNumber, productName: this.query.productName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      if (!id) {
        this.form = emptyForm()
        this.visible = true
        return
      }
      getBatch(id).then(res => {
        const d = res.data || {}
        this.form = {
          batchId: d.batchId, productId: d.productId, batchNo: d.batchNo,
          supplierName: d.supplierName || '',
          mfgDate: d.mfgDate ? String(d.mfgDate).substring(0, 10) : null,
          expireDate: d.expireDate ? String(d.expireDate).substring(0, 10) : null,
          remark: d.remark || ''
        }
        this.visible = true
      })
    },
    submit() {
      if (!this.form.productId) { this.$message.warning('请选择产品'); return }
      if (!this.form.batchNo) { this.$message.warning('请输入批次号'); return }
      this.saving = true
      const req = this.form.batchId ? updateBatch(this.form) : saveBatch(this.form)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.search()
      }).finally(() => { this.saving = false })
    },
    goTrace(row) {
      this.$router.push({
        path: '/inventory/genealogy',
        query: {
          productId: row.productId,
          batchNo: row.batchNo,
          productLabel: (row.productNumber || '') + ' / ' + (row.productName || '')
        }
      }).catch(() => {})
    },
    onDelete(id) {
      this.$confirm('确定删除该批次?', '提示', { type: 'warning' }).then(() => {
        deleteBatch([id]).then(() => { this.$message.success('已删除'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
